// AssignmentModal.jsx — 1:1 배정 추가·고치기 창
//   2026-10-06 UX 5단계: 직접 만든 덮개 → 공용 창(Modal, 휴대폰은 아래 시트). 칸·저장 값은 그대로, 칸·버튼 40px.
import React from 'react';
import Modal from '../../../components/Modal';

const S = {
  body: { display: 'flex', flexDirection: 'column', gap: 14, minWidth: 0 },
  helper: { fontSize: 12, color: 'var(--text-muted)', lineHeight: 1.5 },
  grid: { display: 'grid', gridTemplateColumns: 'repeat(auto-fit,minmax(min(210px,100%),1fr))', gap: 12, minWidth: 0 },
  field: { display: 'flex', flexDirection: 'column', gap: 6, minWidth: 0 },
  label: { fontSize: 12, fontWeight: 800, color: 'var(--text-muted)' },
  input: {
    height: 40, width: '100%', minWidth: 0, maxWidth: '100%', border: '1px solid var(--border)', borderRadius: 10,
    padding: '0 12px', background: 'var(--bg-card)', color: 'var(--text)', fontSize: 14, outline: 'none', boxSizing: 'border-box',
  },
  readOnlyBox: {
    minHeight: 40, border: '1px solid var(--border)', borderRadius: 10, padding: '9px 12px', background: 'var(--bg-subtle)',
    color: 'var(--text)', fontSize: 14, fontWeight: 800, boxSizing: 'border-box',
  },
  textArea: {
    minHeight: 72, border: '1px solid var(--border)', borderRadius: 10, padding: 12, background: 'var(--bg-card)',
    color: 'var(--text)', fontSize: 14, outline: 'none', resize: 'vertical', boxSizing: 'border-box',
  },
  err: {
    border: '1px solid rgba(220,38,38,0.22)', borderRadius: 10, padding: 10, background: 'rgba(220,38,38,0.08)',
    color: '#dc2626', fontSize: 13, fontWeight: 700,
  },
  info: {
    border: '1px solid rgba(37,99,235,0.18)', borderRadius: 10, padding: 10, background: 'rgba(37,99,235,0.08)',
    color: 'var(--text-sub)', fontSize: 13, fontWeight: 600, lineHeight: 1.5,
  },
  footer: { display: 'flex', justifyContent: 'flex-end', gap: 8, flexWrap: 'wrap' },
  btn: {
    minHeight: 40, border: '1px solid var(--border)', borderRadius: 10, padding: '0 14px', background: 'var(--bg-card)',
    color: 'var(--text-sub)', fontSize: 13, fontWeight: 800, cursor: 'pointer',
  },
  primary: {
    minHeight: 40, border: 'none', borderRadius: 10, padding: '0 18px', background: '#2563eb', color: '#fff',
    fontSize: 13, fontWeight: 800, cursor: 'pointer',
  },
};

function formatMoneyInput(value) {
  const raw = String(value || '').replace(/,/g, '');
  if (raw === '') return '';
  if (!/^\d+$/.test(raw)) return null;
  return Number(raw).toLocaleString('ko-KR');
}

export function AssignmentModal({
  mode,
  form,
  marketers,
  consultants,
  lockedMarketer,
  assignment = null,
  saving,
  error,
  onField,
  onSave,
  onClose,
}) {
  const isEdit = mode === 'edit';
  // 고칠 때 지금 1:1 직원이 후보 목록에 없으면(퇴사 등) 이름이 '선택'으로 보이지 않게 맨 앞에 넣어 둔다
  const consultantOptions = isEdit && assignment
    && !consultants.some((user) => String(user.id) === String(assignment.consultant_user_id))
    ? [{ id: assignment.consultant_user_id, name: assignment.consultant_name || '-' }, ...consultants]
    : consultants;
  const title = isEdit
    ? `${assignment?.consultant_name ? `${assignment.consultant_name} ` : ''}기간·메모 고치기`
    : lockedMarketer
      ? `${lockedMarketer.name}에게 1:1 직원 배정`
      : '새 배정';

  const footer = (
    <div style={S.footer}>
      <button type="button" style={S.btn} onClick={onClose} disabled={saving}>취소</button>
      <button type="button" style={S.primary} onClick={onSave} disabled={saving}>{saving ? '저장 중' : '저장'}</button>
    </div>
  );

  return (
    <Modal open title={title} icon="👤" onClose={onClose} footer={footer} width="min(720px, calc(100vw - 48px))" mobileSheet>
      <div style={S.body}>
        <div style={S.helper}>
          {isEdit
            ? '시작일·끝나는 날·메모만 고쳐요. 월급·인센티브·연차는 배정 상세의 [급여 조건]에서 바꿔요.'
            : '저장하면 아래 월급으로 첫 급여 조건이 함께 만들어져요. 인센티브 등은 저장 뒤 [급여 조건]에서 정해요.'}
        </div>

        <div style={S.grid}>
          <label style={S.field}>
            <span style={S.label}>마케터 *</span>
            {lockedMarketer ? (
              <div style={S.readOnlyBox}>{lockedMarketer.name}</div>
            ) : (
              <select style={S.input} value={form.marketer_user_id} onChange={(e) => onField('marketer_user_id', e.target.value)}>
                <option value="">선택</option>
                {marketers.map((user) => <option key={user.id} value={user.id}>{user.name}</option>)}
              </select>
            )}
          </label>

          <label style={S.field}>
            <span style={S.label}>1:1 직원 *</span>
            <select style={S.input} value={form.consultant_user_id} onChange={(e) => onField('consultant_user_id', e.target.value)}>
              <option value="">선택</option>
              {consultantOptions.map((user) => <option key={user.id} value={user.id}>{user.name}</option>)}
            </select>
          </label>
        </div>

        <div style={S.grid}>
          <label style={S.field}>
            <span style={S.label}>시작일 *</span>
            <input type="date" style={S.input} value={form.start_date} onChange={(e) => onField('start_date', e.target.value)} />
          </label>
          <label style={S.field}>
            <span style={S.label}>끝나는 날 (비우면 계속)</span>
            <input type="date" style={S.input} value={form.end_date} onChange={(e) => onField('end_date', e.target.value)} />
          </label>
        </div>

        {isEdit ? (
          <div style={S.info}>월급은 기간마다 다를 수 있어서 '급여 조건'에서 적용 시작일과 함께 바꿔요.</div>
        ) : (
          <label style={S.field}>
            <span style={S.label}>첫 급여 조건 월급</span>
            <input
              type="text"
              inputMode="numeric"
              style={S.input}
              placeholder="0"
              value={form.monthly_salary}
              onChange={(e) => {
                const next = formatMoneyInput(e.target.value);
                if (next !== null) onField('monthly_salary', next);
              }}
            />
          </label>
        )}

        <label style={S.field}>
          <span style={S.label}>메모</span>
          <textarea style={S.textArea} value={form.notes} onChange={(e) => onField('notes', e.target.value)} />
        </label>

        {error && <div style={S.err}>{error}</div>}
      </div>
    </Modal>
  );
}
